import React from 'react';
import AppDialog from '../AppDialog/AppDialog';
import { t } from '../../utils/i18n';
import { BAN_ACTION } from '../../utils/userBanActions';

/**
 * Confirm + result alert dialogs for user ban/unban flow.
 */
export default function UserBanDialog({ dialog, onConfirm, onCancel, loading }) {
  if (!dialog) return null;

  if (dialog.kind === 'confirm') {
    const isBan = dialog.action === BAN_ACTION;
    return (
      <AppDialog
        open
        mode="confirm"
        variant={isBan ? 'danger' : 'success'}
        title={isBan ? t('user.ban.dialog.titleBan') : t('user.ban.dialog.titleUnban')}
        message={dialog.message}
        confirmLabel={isBan ? t('user.ban.button') : t('user.ban.unban.button')}
        onConfirm={onConfirm}
        onCancel={onCancel}
        loading={loading}
      />
    );
  }

  if (dialog.kind === 'alert') {
    const isError = dialog.variant === 'error';
    return (
      <AppDialog
        open
        mode="alert"
        variant={isError ? 'danger' : 'success'}
        title={isError ? t('user.ban.dialog.titleError') : t('user.ban.dialog.titleSuccess')}
        message={dialog.message}
        onCancel={onCancel}
      />
    );
  }

  return null;
}
